import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\ReservationController::create
* @see app/Http/Controllers/ReservationController.php:39
* @route '/rezervace'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/rezervace',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReservationController::create
* @see app/Http/Controllers/ReservationController.php:39
* @route '/rezervace'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::create
* @see app/Http/Controllers/ReservationController.php:39
* @route '/rezervace'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::create
* @see app/Http/Controllers/ReservationController.php:39
* @route '/rezervace'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReservationController::continueMethod
* @see app/Http/Controllers/ReservationController.php:545
* @route '/rezervace/pokracovat/{uuid}'
*/
export const continueMethod = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: continueMethod.url(args, options),
    method: 'get',
})

continueMethod.definition = {
    methods: ["get","head"],
    url: '/rezervace/pokracovat/{uuid}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReservationController::continueMethod
* @see app/Http/Controllers/ReservationController.php:545
* @route '/rezervace/pokracovat/{uuid}'
*/
continueMethod.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return continueMethod.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::continueMethod
* @see app/Http/Controllers/ReservationController.php:545
* @route '/rezervace/pokracovat/{uuid}'
*/
continueMethod.get = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: continueMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::continueMethod
* @see app/Http/Controllers/ReservationController.php:545
* @route '/rezervace/pokracovat/{uuid}'
*/
continueMethod.head = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: continueMethod.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReservationController::processStep
* @see app/Http/Controllers/ReservationController.php:334
* @route '/rezervace/step'
*/
export const processStep = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: processStep.url(options),
    method: 'post',
})

processStep.definition = {
    methods: ["post"],
    url: '/rezervace/step',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ReservationController::processStep
* @see app/Http/Controllers/ReservationController.php:334
* @route '/rezervace/step'
*/
processStep.url = (options?: RouteQueryOptions) => {
    return processStep.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::processStep
* @see app/Http/Controllers/ReservationController.php:334
* @route '/rezervace/step'
*/
processStep.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: processStep.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ReservationController::store
* @see app/Http/Controllers/ReservationController.php:134
* @route '/rezervace'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/rezervace',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ReservationController::store
* @see app/Http/Controllers/ReservationController.php:134
* @route '/rezervace'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::store
* @see app/Http/Controllers/ReservationController.php:134
* @route '/rezervace'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ReservationController::clearSession
* @see app/Http/Controllers/ReservationController.php:581
* @route '/rezervace/clear-session'
*/
export const clearSession = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: clearSession.url(options),
    method: 'delete',
})

clearSession.definition = {
    methods: ["delete"],
    url: '/rezervace/clear-session',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ReservationController::clearSession
* @see app/Http/Controllers/ReservationController.php:581
* @route '/rezervace/clear-session'
*/
clearSession.url = (options?: RouteQueryOptions) => {
    return clearSession.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::clearSession
* @see app/Http/Controllers/ReservationController.php:581
* @route '/rezervace/clear-session'
*/
clearSession.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: clearSession.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ReservationController::success
* @see app/Http/Controllers/ReservationController.php:596
* @route '/rezervace/uspech/{uuid}'
*/
export const success = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: success.url(args, options),
    method: 'get',
})

success.definition = {
    methods: ["get","head"],
    url: '/rezervace/uspech/{uuid}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReservationController::success
* @see app/Http/Controllers/ReservationController.php:596
* @route '/rezervace/uspech/{uuid}'
*/
success.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return success.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::success
* @see app/Http/Controllers/ReservationController.php:596
* @route '/rezervace/uspech/{uuid}'
*/
success.get = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: success.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::success
* @see app/Http/Controllers/ReservationController.php:596
* @route '/rezervace/uspech/{uuid}'
*/
success.head = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: success.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReservationController::show
* @see app/Http/Controllers/ReservationController.php:785
* @route '/rezervace/{uuid}'
*/
export const show = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/rezervace/{uuid}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReservationController::show
* @see app/Http/Controllers/ReservationController.php:785
* @route '/rezervace/{uuid}'
*/
show.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return show.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::show
* @see app/Http/Controllers/ReservationController.php:785
* @route '/rezervace/{uuid}'
*/
show.get = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::show
* @see app/Http/Controllers/ReservationController.php:785
* @route '/rezervace/{uuid}'
*/
show.head = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReservationController::cancel
* @see app/Http/Controllers/ReservationController.php:950
* @route '/rezervace/{uuid}/zrusit'
*/
export const cancel = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/rezervace/{uuid}/zrusit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ReservationController::cancel
* @see app/Http/Controllers/ReservationController.php:950
* @route '/rezervace/{uuid}/zrusit'
*/
cancel.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return cancel.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::cancel
* @see app/Http/Controllers/ReservationController.php:950
* @route '/rezervace/{uuid}/zrusit'
*/
cancel.post = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

const reservations = {
    create: Object.assign(create, create),
    continue: Object.assign(continueMethod, continueMethod),
    processStep: Object.assign(processStep, processStep),
    store: Object.assign(store, store),
    clearSession: Object.assign(clearSession, clearSession),
    success: Object.assign(success, success),
    show: Object.assign(show, show),
    cancel: Object.assign(cancel, cancel),
}

export default reservations